import React from 'react';
import PropTypes from 'prop-types';
import InstallListItem from './InstallListItem';

export default class CustomerIndex extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    installations: PropTypes.object.isRequired,
  };

  renderInstallation = install => {
    const { installation } = install;
    const installId = installation.get('id');
    return <InstallListItem key={installId} install={install} />;
  };

  render() {
    const { account, installations } = this.props;
    const whiteLabelCompany = account.get('companyName');

    return (
      <div className="modal-wrap">
        <div className="row row-top">
          <div className="col-xs-12">
            <h1>Choose Your {whiteLabelCompany} Instance</h1>
          </div>
        </div>
        {installations.size > 0 ? (
          installations.valueSeq().map(this.renderInstallation)
        ) : (
          <div className="row row-top">
            <div className="col-xs-12">
              <br />
              <p>It looks like you currently don&apos;t have any installations.</p>
              <p>Please contact your administrator if you think this is in error.</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
